import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';

import MillieApi         from 'app/apis/millie';
import GroupsAx          from 'app/actions/groups';
import {
  UserEmailTypes,
}                        from 'app/constants';
import HappeningsDuck    from 'app/ducks/happenings';
import history           from 'app/history';
import paths             from 'app/paths';
import reducerUtils      from 'app/reducers/utils';
import AuthSlx           from 'app/selectors/auth';
import EntitiesSlx       from 'app/selectors/entities';
import RoutingSlx        from 'app/selectors/routing';

const noop = () => {};
const keyCbMap = {};



/*
 *  Actions
 */

const Types = {
  CONFIRM: 'PROMPTS_CONFIRM',
  CONFIRM_RESPOND: 'PROMPTS_CONFIRM_RESPOND',
  PE_REQUIRE: 'PROMPTS_PE_REQUIRE',
  PE_DISMISS: 'PROMPTS_PE_DISMISS',
  PE_SUBMIT: 'PROMPTS_PE_SUBMIT',
  PE_RESET_FORM: 'PROMPTS_PE_RESET_FORM',
};

const Ax = {

  confirm: (opts, cb) => (dispatch, getState) => {
    const key = `${Math.random()}`;
    keyCbMap[key] = cb;
    return dispatch({type: Types.CONFIRM, key, opts});
  },

  confirmRespond: (key, didConfirm) => (dispatch, getState) => {
    const cb = keyCbMap[key] || noop;
    delete keyCbMap[key];
    cb(didConfirm);
    return dispatch({type: Types.CONFIRM_RESPOND, key});
  },

  requirePersonalEmail: (destination='/', cb) => (dispatch, getState) => {
    const alreadyHasPeronsalEmail = Slx.hasPersonalEmail(getState());
    if (alreadyHasPeronsalEmail) return cb(true);
    return dispatch({type: Types.PE_REQUIRE, cb});
  },

  dismissPersonalEmail: () => (dispatch, getState) => {
    const hasPeronsalEmail = Slx.hasPersonalEmail(getState());
    const cb = Slx.rpeCb(getState());
    cb && cb(hasPeronsalEmail);
    return dispatch({type: Types.PE_DISMISS});
  },

  submitPersonalEmail: (email) => (dispatch, getState) => {
    const promise = MillieApi.accountSetPersonalEmail(email);
    return dispatch({type: Types.PE_SUBMIT, promise});
  },

  resetPersonalEmailForm: () => {
    return {type: Types.PE_RESET_FORM};
  },

};



/*
 *  Reducer
 */

const initialState = {
  confirms: [],
  // rpe = require personal email
  rpeCb: null,
  rpeSubmitPending: false,
  rpeSubmitFailed: false,
  rpeSubmitSuccess: false,
  rpeValidations: null,
};

const reducer = reducerUtils.createReducer(initialState, {

  [Types.CONFIRM]: (state, action) => {
    const {key, opts} = action;
    return {...state,
      confirms: [...state.confirms,
        {key, opts},
      ],
    };
  },

  [Types.CONFIRM_RESPOND]: (state, action) => {
    const confirms = _.filter(state.confirms, (confirm) => {
      return confirm.key !== action.key;
    });
    return {...state,
      confirms,
    };
  },

  [Types.PE_REQUIRE]: (state, action) => {
    return {...state,
      rpeCb: action.cb,
    };
  },

  [Types.PE_DISMISS]: (state, action) => {
    return {...state,
      rpeCb: null,
    };
  },

  [`${Types.PE_SUBMIT}_PENDING`]: (state, action) => {
    return {...state,
      rpeSubmitPending: true,
      rpeSubmitFailed: false,
      rpeValidations: null,
    };
  },
  [`${Types.PE_SUBMIT}_RESOLVED`]: (state, action) => {
    return {...state,
      rpeSubmitPending: false,
      rpeSubmitSuccess: true,
    };
  },
  [`${Types.PE_SUBMIT}_REJECTED`]: (state, action) => {
    const validations = _.get(action, 'error.response.data.error.validations', null);
    return {...state,
      rpeSubmitPending: false,
      rpeSubmitFailed: true,
      rpeValidations: validations,
    };
  },

  [Types.PE_RESET_FORM]: (state, action) => {
    return {...state,
      rpeSubmitPending: false,
      rpeSubmitFailed: false,
      rpeSubmitSuccess: false,
      rpeValidations: null,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selConfirms         = state => state.prompts.confirms;
  const selRpeCb            = state => state.prompts.rpeCb;
  const selRpeSubmitPending = state => state.prompts.rpeSubmitPending;
  const selRpeSubmitFailed  = state => state.prompts.rpeSubmitFailed;
  const selRpeSubmitSuccess = state => state.prompts.rpeSubmitSuccess;
  const selRpeValidations   = state => state.prompts.rpeValidations;

  const selConfirm = createSelector(
    [selConfirms],
    (confirms) => (_.last(confirms) || null)
  );

  const selShowRpe = createSelector(
    [selRpeCb],
    (rpeCb) => !!rpeCb,
  );

  const selHasPersonalEmail = createSelector(
    [AuthSlx.currentUser],
    (currentUser) => {
      if (!currentUser) return true; // if there's not a current user, then this should be irrelevent, so default to allowing
      return currentUser.emailType === UserEmailTypes.PERSONAL;
    }
  );

  return {
    confirm: selConfirm,
    showRpe: selShowRpe,
    rpeCb: selRpeCb,
    rpeSubmitPending: selRpeSubmitPending,
    rpeSubmitFailed: selRpeSubmitFailed,
    rpeSubmitSuccess: selRpeSubmitSuccess,
    rpeValidations: selRpeValidations,
    hasPersonalEmail: selHasPersonalEmail,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
